<template>
  <div>
    <div class="bg-dark">
      <div class="px-5 flex items-center justify-between">
        <vs-button color="dark" icon="menu" @click="toggleMenu()"></vs-button>

        <div class="flex gap-4 items-center text-white text-xs">
          <div class="flex items-center gap-2">
            <i :alt="geolocation.latitude + ' ' + geolocation.longitude" class="fas fa-map-marker-alt text-success"
              v-if="geolocation !== null"></i>
            <i class="fas fa-map-marker-alt text-danger" v-else></i>

          </div>
          <code class="pill-secondary pulse-secondary hidden lg:block" v-if="developmentMode">Modo desarrollador</code>

          <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
            <div class="tiie-item text-xs">
              <em class="fas fa-circle" v-bind:class="{
                'text-danger': fundTiieState === 'down',
                'text-success': fundTiieState === 'up'
              }"></em>
              TIIE <br /> <strong class="text-sm">{{ fundTiie }} %</strong>
            </div>
            <vs-dropdown-menu class="notification-dropdown dropdown-custom vx-navbar-dropdown">
              <div class="notification-top bg-primary text-center p-5 text-white">
                <p class="text-white">Información Banxico TIIE</p>
              </div>
              <ul class="bordered-items">
                <li class="flex justify-between px-4 py-3 notification cursor-pointer">
                  <strong>Banxico TIIE</strong> {{ fundTiie }} %
                </li>
                <li class="flex justify-between px-4 py-3 notification cursor-pointer">
                  <strong>Fecha de consulta</strong> {{ tiieQueryDate }}
                </li>
                <li class="flex justify-between px-4 py-3 notification cursor-pointer">
                  <strong>Oferta Tasa Base RG (excedente TIIE)</strong> {{ surplus.toFixed(2) }}
                </li>
                <li class="flex justify-between px-4 py-3 notification cursor-pointer">
                  <strong>Step calificaciones</strong> {{ step.toFixed(2) }}
                </li>
                <li class="flex justify-between px-4 py-3 notification cursor-pointer">
                  <strong>RedGirasol Tasa Base ({{ qualification }})</strong> {{ rgInterestBase.toFixed(2) }} %
                </li>
                <li class="flex justify-between px-4 py-3 notification cursor-pointer">
                  <strong>Actualizar TB (Pts. porcentuales)</strong> {{ tiiePercentagePoints.toFixed(2) }}
                </li>
                <li class="flex justify-between px-4 py-3 notification cursor-pointer">
                  <strong>Nueva Tasa Base RG ({{ qualification }})</strong> {{ rgInterestSuggested.toFixed(2) }} %
                </li>
              </ul>
            </vs-dropdown-menu>
          </vs-dropdown>

          <span class="hidden lg:block" v-if="udis != null">UDIS <br /> <strong>{{ udis }} MXN</strong></span>
          <span class="hidden lg:block" v-if="usdExchange != null">FIX <br /><strong>{{ usdExchange[0].exchange_mxn_usd
          }}
              MXN</strong></span>
          <span class="hidden lg:block" v-if="usdExchange != null">DOF <br /><strong>{{ usdExchange[1].exchange_mxn_usd
          }}
              MXN</strong></span>
          <span class="hidden lg:block" v-if="usdExchange != null">F. Consulta
            <br /><strong>{{ usdExchange[0].query_date }}</strong></span>
          <vs-button color="secondary" class="text-black rounded-full" icon="headset_mic" target="_blank"
            rel="noopener noreferrer" href="https://redgirasol.atlassian.net/servicedesk/customer/portals">
          </vs-button>
          <vs-button class="text-black rounded-full" color="secondary" icon="support" target="_blank"
            rel="noopener noreferrer" href="https://sites.google.com/redgirasol.com/documentacionrg/pagina-principal">
          </vs-button>

          <vs-button @click="_logout()" icon="exit_to_app" color="danger" class="small">
            Cerrar sesión
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex';

export default {
  name: "TopToolbar.vue",
  data: () => ({
    developmentMode: process.env.VUE_APP_ENV === "development"
  }),
  computed: {
    ...mapState("auth", ["isLogged", "user", "geolocation"]),
    ...mapState("misc", [
      "udis",
      "usdExchange",
      "qualification",
      "surplus",
      "step",
      "rgInterestSuggested",
      "fundTiie",
      "fundTiieState",
      "rgInterestBase",
      "tiieQueryDate",
      "tiiePercentagePoints"
    ]),
  },
  methods: {
    ...mapActions('auth', ["logout"]),
    ...mapMutations('menu', ['toggleMenu']),
    async _logout() {
      await this.logout();
      this.$router.push("/login");
    }
  }
}
</script>

<style scoped>
.tiie-item {
  padding-right: 10px;
  padding-top: 1px;
  width: 5vw;
}
</style>
